import { defineMessages } from 'react-intl'

const scope = `procurify.components.Budgets.BudgetIntervalSelect`

export default defineMessages({
  budgetIntervalSelectPlaceholder: {
    id: `${scope}.budgetIntervalSelectPlaceholder`,
    defaultMessage: 'Select an option',
  },
  entireDateRangeOption: {
    id: `${scope}.entireDateRangeOption`,
    defaultMessage: 'Entire Date Range',
  },
  monthlyOption: {
    id: `${scope}.monthlyOption`,
    defaultMessage: 'Each Month',
  },
  quarterlyOption: {
    id: `${scope}.quarterlyOption`,
    defaultMessage: 'Each Quarter',
  },
  yearlyOption: {
    id: `${scope}.yearlyOption`,
    defaultMessage: 'Each Year',
  },
})
